<template>
  <b-container fluid class="bg-mint pl-5 pr-5 pt-5">
    <b-row class="pt-5">
      <b-col>
        <h2 class="mb-4 pt-3 text-center">Testimonials</h2>
      </b-col>
    </b-row>
    <b-row class="justify-content-around">
      <b-col
        v-for="(testimonial, index) in testimonials"
        :key="index"
        cols="12"
        md="6"
        xl="2"
        class="text-center pl-1 pr-1 mb-5"
      >
        <img
          :src="testimonial.src"
          style="width: 76%; max-width: 226px"
          :alt="`Speaker named ${testimonial.name}`"
        />
        <p class="text-left mt-3">
          {{ testimonial.text }}
        </p>
        <p class="text-left mb-0">
          <b>-{{ testimonial.name }}</b>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742800149/2025/Tickets_page/Corin_Ism.png",
          text: "Øredev is a focal point for kind and skilled people who understand technology as muscle to deliver on human desires.",
          name: "Corin Ism",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/Phil_Nash.png",
          text: "Øredev is an incredible conference, the curation of talks takes you from things you can improve today to contemplating the future of humanity and nothing feels out of place. Everything about the event is built to help you learn or help you meet new connections, I did both and had a great time!",
          name: "Phil Nash",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742800149/2025/Tickets_page/Juulia_Suvilehto.png",
          text: "I felt like Øredev was such a perfect goldilocks size - not too big, not too small, just right. And the energy and vibe were so friendly and contagious ☺️",
          name: "Juulia Suvilehto",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/Sandy_Mamoli.png",
          text: 'One of my favourite experiences both as a speaker and as an attendee. Great sessions, great programme and as speaker I was taken really good care of. Epic programme "on and off the pitch"!',
          name: "Sandy Mamoli",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/Saravanan_Nagarajan.png",
          text: "Øredev is THE tech conference to attend in the Nordic region. Fantastically executed event with the help of a very capable team - Kudos to all those involved!",
          name: "Saravanan K Nagarajan",
        },
      ],
    };
  },
  computed: {
    testimonials() {
      return this.items;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/TicketsPage/Testimonials.vue